<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<a id="ad_card_1">
</a>
<p class="ach">O<span class="small">THER</span> B<span class="small">OOKS BY</span> A<span class="small">MANDA</span> S<span class="small">COTT</span>
</p>
<p class="acl">
<em>KNIGHT’S TREASURE</em>
</p>
<p class="acl">
<em>LADY’S CHOICE</em>
</p>
<p class="acl">
<em>PRINCE OF DANGER</em>
</p>
<p class="acl">
<em>LORD OF THE ISLES</em>
</p>
<p class="acl">
<em>HIGHLAND PRINCESS</em>
</p>
<p class="acl">
<em>THE SECRET CLAN: REIVER’S BRIDE</em>
</p>
<p class="acl">
<em>THE SECRET CLAN: HIGHLAND BRIDE</em>
</p>
<p class="acl">
<em>THE SECRET CLAN: HIDDEN HEIRESS</em>
</p>
<p class="acl">
<em>THE SECRET CLAN: ABDUCTED HEIRESS</em>
</p>
<p class="acl">
<em>BORDER FIRE</em>
</p>
<p class="acl">
<em>BORDER STORM</em>
</p>
<p class="acl">
<em>BORDER BRIDE</em>
</p>
<p class="acl">
<em>HIGHLAND FLING</em>
</p>
<p class="acl">
<em>HIGHLAND SECRETS</em>
</p>
<p class="acl">
<em>HIGHLAND TREASURE</em>
</p>
<p class="acl">
<em>HIGHLAND SPIRITS</em>
</p>
<p class="acl">
<em>THE BAWDY BRIDE</em>
</p>
<p class="acl">
<em>DANGEROUS ILLUSIONS</em>
</p>
<p class="acl">
<em>DANGEROUS ANGELS</em>
</p>
<p class="acl">
<em>DANGEROUS GAMES</em>
</p>
<p class="acl">
<em>DANGEROUS LADY</em>
</p>
<p class="acl">
<em>THE ROSE AT TWILIGHT</em>
</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// KingofStorms_ad_card_1.vue?599d0e26